import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withRouter } from 'next/router';
import { FormattedMessage } from 'react-intl';
import { Button } from '../../components/Generic/Button';
import Breadcrumb from '../../components/Brand/Shared/Breadcrumb';
import {
  ProductCarousel,
  ArticleCarousel,
} from '../../components/Brand/ProductCarousel';
import PGDataLayer from '../../components/Generic/PGDataLayer/PGDataLayer';
import Image from 'next/image';
import DOMPurify from 'isomorphic-dompurify';
import fs from 'fs';
import { allLanguages, defaultLocale } from '../../constants/languages';
import PageMetadata from '../../components/Generic/PageMetadata';
import store from '../../store/ProductStore';
import getInitialData from '../../utils/helpers/initialDataHelper';
import {
  contentType,
  productPage,
  contentfulConstant,
  bazaarVoiceFileName,
} from '../../constants/global';
import config from '../../config';
import { ReadReview } from '../../components/Generic/ReadReview';
import { defaultLangKey } from '../../constants/languages';
import styles from '../../components/Brand/Product/ProductDetails-tw-styles';
import { renderSection } from '../../utils/uiHelper';
import Media from "../../components/Generic/Carousel/CarouselMedia";
import IconBanner from "../../components/Generic/IconBanner/IconBanner";
import SectionBanner from "../../components/Brand/SectionBanner/SectionBanner";
import BottomBanner from "../../components/Generic/BottomBanner/BottomBanner";
import RatingAndReviewSection from "../../components/Generic/Rating/RatingAndReviewSection";

import JamieBanner from '../../components/Brand/Product/JamieBanner';
import {
  Dialog,
  DialogTitle,
  DialogContent,
} from '../../components/Generic/Dialog';
import { getReviews } from '../../services/bazaarvoice-api';
import loadScripts from '../../utils/scriptsHelper';
import LazyLoad from 'react-lazy-load';
import i18nMessages ,{ratingsReviewsID, ratingsReviews }from '../../constants/messages/pt-BR';
import { SEOProduct } from '../../components/Brand/SEO';
import BuyNowLiteComponent from '../../components/Generic/BuyNowLite';
import HeadingBanner from '../../components/Brand/HeadingBanner';
import NewHeadingBanner from '../../components/Brand/HeadingBanner/NewHeadingBannner';
import UserInstructions from '../../components/Brand/UserInstructions';
import dynamic from 'next/dynamic';
const Typography = dynamic(() => import('../../components/Generic/Typography'));
const Carousel = dynamic(() => import('../../components/Brand/Carousel'));
import HeaderNav from '../../components/Brand/HeaderNav/HeaderNav';
import BazaarVoiceMetaTags from "../../components/Generic/BVLoader/BVLoader";
import FAQBlock from '../../components/Brand/FAQBlock';
import { json } from 'express';
import BambuPageBanner from '../../components/Brand/Product/Bambu';


class ProductDetail extends Component {
  static propTypes = {
    pageContext: PropTypes.oneOfType([PropTypes.object]).isRequired,
    data: PropTypes.oneOfType([PropTypes.object]).isRequired,
  };
  static async getInitialProps({ query }) {
    let reviewData;
    let data = await getInitialData(
      contentfulConstant,
      contentType.productPage,
      query.locale || defaultLangKey,
      query
    );
    let bvReviews = await getInitialData(
      bazaarVoiceFileName,
      bazaarVoiceFileName,
      query.locale || defaultLangKey,
      data.data.productCollection.items[0]
    );

    let extraProductPageData = {};
    if (data?.data?.productCollection?.items[0]?.isNewTemplate) {
      extraProductPageData = await getInitialData(
        contentfulConstant,
        contentType.newProductPage,
        query.locale || defaultLangKey,
        query,
        true
      );
    }

    if (data?.data?.productCollection?.items[0]) {
      const productId = data?.data?.productCollection?.items[0]?.ratingAndReviewId;
      const limit =
        config.bazaarvoice[query.locale].preloadConfig.numberOfReviews;
      let sortFilterValue = '&sort=Rating:desc';

      if (productId) {
        await getReviews(
          productId,
          limit,
          0,
          sortFilterValue,
          query.locale || defaultLangKey
        )
          .then(res => {
            reviewData = res.data && res.data.Results;
          })
          .catch(err => {
            // Do not fail static export for a product page when reviews API is unavailable.
            console.error('Bazaarvoice preload failed for product', productId, err?.message || err);
            reviewData = [];
          });
      }
    }
    return {
      data: {
        ...data.data,

        productExtraPageData: {
          ...extraProductPageData.data,

        },
        bvReviews, reviewData
      },
      pageContext: query,
    };
  }
  constructor(props) {
    super(props);
    this.state = {
      dialogOpen: false,
      showNavHeader: false,
    };
    this.scrollPosition = 0;
    this.scrollDirection;
    this.animationLoaded = false;
    this.scriptsLoaded = false;
    const { data, pageContext } = this.props;
    const productIdArr = [];
    let productDetail = data.productCollection.items[0];
    productIdArr.push(productDetail && productDetail.ratingAndReviewId);
    store.getPreloadConfig(pageContext.locale);

    if (store.preloadBVReviews) {
      if (data.bvReviews) {
        store.ratingData = data.bvReviews;

        const reviewResults =
          data.bvReviews.Results &&
          data.bvReviews.Results.slice(0, store.limit);
        const reviewDataObj = {
          Results: reviewResults,
          TotalReviewCount: data.bvReviews.TotalReviewCount,
        };
        store.reviewData = reviewDataObj;
      }
    } else {
      store.primaryRating(productIdArr, pageContext.locale);
    }
  }
  componentDidUpdate() {
    if (window && window.SmartCart) {
      window.SmartCart.updateUsaWidget();
    }
  }

  componentDidMount() {
    if (typeof window !== 'undefined') {
      window.io_bbout_element_id = 'ioBlackBox';
    }
    
    let scripts = [
      '/static/scripts/animation/ScrollMagic.min.js',
      '/static/scripts/animation/TweenMax.min.js',
      '/static/scripts/animation/animation.gsap.min.js',
    ];
    loadScripts(scripts, () => {
      this.scriptsLoaded = true;
      // Give a small delay to ensure UserInstructions component is fully rendered
      setTimeout(() => {
        // Check if we have the basic elements needed for animation
        const hasMiddleSection = document.querySelector('#middleSection');
        const hasBodyContainer = document.querySelector('#bodyContainer');

        // Load animation if either middleSection or bodyContainer exists
        if (hasMiddleSection || hasBodyContainer) {
          this.loadAnimation();
        }
      }, 100);
    });
    var myTimeout = setInterval(() => {
      if (window && window.SmartCart) {
        window.SmartCart.updateUsaWidget();
        clearTimeout(myTimeout);
      }
    }, 500);
    this.handleWindowChange();
    window.addEventListener("resize", this.handleWindowChange);
    window.addEventListener("scroll", this.handleScroll);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.handleWindowChange);
    window.removeEventListener("scroll", this.handleScroll);
  }
  handleWindowChange = () => {
    const isMobile = window.innerWidth < 1024;
    this.setState({
      isMobile: isMobile,
    });
  };
  handleScroll = () => {
    const winPageY = window.pageYOffset + 90;
    this.scrollDirection =
      document.body.getBoundingClientRect().top > this.scrollPosition
        ? "up"
        : "down";
    this.scrollPosition = document.body.getBoundingClientRect().top;

    // Trigger animation loading on scroll if scripts are loaded but animation isn't
    if (this.scriptsLoaded && !this.animationLoaded) {
      const middleSection = document.querySelector('#middleSection');
      if (middleSection) {
        const middleSectionTop = middleSection.offsetTop;
        const scrollTriggerPoint = middleSectionTop - window.innerHeight;
        // Load animation when user scrolls close to the UserInstructions section
        if (winPageY > scrollTriggerPoint) {
          this.loadAnimation();
        }
      }
    }

    const isOldTemplate = !this.props.data.productCollection.items[0]?.isNewTemplate;
    const buyNowId =
      window.innerWidth >= 1024 ? "buy-now-light-desktop" : "buy-now-mob";
    let buynowTop = document.getElementById(buyNowId)?.offsetTop
      || document.getElementById("buyNowBtnWrapper")?.offsetTop
      || document.getElementById("buyNowBtn")?.offsetTop;
    
    // Fallback: Use product image or heading section if buy-now element not found
    if (!buynowTop) {
      const fallbackElement = document.querySelector('.pdpwrapper') 
        || document.querySelector('.product-image-wrapper-desktop')
        || document.querySelector('.product-image-wrapper-mobile');
      if (fallbackElement) {
        buynowTop = fallbackElement.offsetTop + 300; // Add offset to trigger after hero section
      } else {
        buynowTop = 500; // Default fallback value
      }
    }
    
    if (isOldTemplate && window.innerWidth >= 1024) {
      const commonBanner = document.querySelector('.commonBannerStyle');
      if (commonBanner) {
        buynowTop = commonBanner.offsetTop + commonBanner.offsetHeight;
      }
    }
    
    // Don't show header nav for old template on mobile
    if (isOldTemplate && window.innerWidth < 1024) {
      if (this.state.showNavHeader) {
        this.setState({ showNavHeader: false });
      }
      return;
    }
    
    if (window.innerWidth < 1024) {
      if (!this.state.showNavHeader && this.scrollDirection === "up") {
        if (winPageY < buynowTop + 100) {
          this.setState({ showNavHeader: false });
        }
      } else if (
        this.state.showNavHeader &&
        this.scrollDirection === "up"
      ) {
        if (winPageY < buynowTop + 100) {
          this.setState({ showNavHeader: false });
        }
      } else {
        if (winPageY > buynowTop)
          this.setState({ showNavHeader: true });
      }
    } else {
      if (!this.state.showNavHeader && this.scrollDirection === "up") {
        if (winPageY < buynowTop + 100) {
          this.setState({ showNavHeader: false });
        }
      } else if (
        this.state.showNavHeader &&
        this.scrollDirection === "up"
      ) {
        if (winPageY < buynowTop + 100) {
          this.setState({ showNavHeader: false });
        }
      } else {
        if (winPageY > buynowTop + 100) {
          this.setState({ showNavHeader: true });
        }
      }
    }

  }

  handleDialogOpen = () => {
    const { dialogOpen: dialogStatus } = this.state;
    this.setState({
      dialogOpen: !dialogStatus,
    });
  };

  loadAnimation = () => {
    if (this.animationLoaded) {
      return; // Prevent loading animation multiple times
    }
    this.animationLoaded = true;
    let ScrollAnimation = document.createElement('script');
    ScrollAnimation.src = '/static/scripts/animation/scrollAnimation.js';
    ScrollAnimation.async = false;
    ScrollAnimation.onload = () => {
      // Manually trigger the animation initialization after script loads
      // since window.onload has already fired
      if (typeof window !== 'undefined' && window.main) {
        window.main();
      }
    };
    document.head.appendChild(ScrollAnimation);
  }

  render() {
    const pageData = this.props.data.productCollection.items[0];
    const extraData = this.props?.data?.productExtraPageData?.productCollection?.items?.[0];
    let isNewTemplate = false;
    let PDPCarouselImageList = [];
    if (pageData?.isNewTemplate) {
      PDPCarouselImageList =
        pageData.pdpCarouselCollection?.items?.[0].pdpImagesCollection
    }
    const { pageContext, data, router } = this.props;
    const { dialogOpen } = this.state;
    const { isMobile } = this.state;
    const product = data.productCollection.items[0];
    const bvData = data.bvReviews;
    const constants = require(`../../constants/messages/${pageContext.locale}`);
    const {
      topBanner,
      simpleBanner,
      middleBannerSection,
      bottomBanner,
      ratingReviewSection,
      faqSectionCollection = []
    } = pageData || {};
    
    


    return (
      <React.Fragment>
        {product && product.pageMetadata && (
          <PGDataLayer
            locale={pageContext.locale}
            data={data}
            pageType={contentType.productPage}
            path={router.asPath}
            title={product.pageMetadata && product.pageMetadata.pageTitle}
          />
        )}
        {product && product.pageMetadata && (
          <PageMetadata
            title={product.pageMetadata.pageTitle}
            metaTitle={product.pageMetadata.metaTitle}
            metaDescription={
              product.pageMetadata.metaDescription &&
              product.pageMetadata.metaDescription
            }
            orgTitle={
              product.pageMetadata && product.pageMetadata.openGraphPageTitle
            }
            orgDescription={
              product.pageMetadata && product.pageMetadata.openGraphDescription
            }
            orgType="article"
            orgImage={
              product.pageMetadata.ogImage && product.pageMetadata.ogImage.url
            }
            twitterImage={
              product.pageMetadata.ogImage && product.pageMetadata.ogImage.url
            }
            metaKeywords={
              product.pageMetadata && product.pageMetadata.metaKeywords
            }
            twitterCard="summary_large_image"
          />
        )}
        <SEOProduct
          productData={product}
          bvData={bvData}
          bvReviewData={data.reviewData}
          locale={pageContext.locale}
        />
        <HeaderNav
          showHeader={this.state.showNavHeader}
          headerImage={pageData.productImage?.url}
          pageData={pageData}
          productName={pageData.productName}
          locale={pageContext.locale}
        />
        <BazaarVoiceMetaTags />
        <div className={classNames(styles.breadcrumbContainer)}>
          <Breadcrumb
            locale={pageContext.locale}
            currentUrl={router.asPath}
            pageType={contentType.productPage}
          />
        </div>
        {pageData?.isNewTemplate && pageData?.isNewTemplate ?
          <div className={styles.pdpwrapper}>
            <NewHeadingBanner
              pageData={pageData}
              product={product}
              locale={pageContext.locale}
              variant={
                pageData &&
                pageData.variantsCollection &&
                pageData.variantsCollection.items
              }
              store={store}
              constants={constants}
              imageList={PDPCarouselImageList.items}
              productFeatureList={pageData?.productDetailsCollection}

            />

            {/* Top Banner */}
            <JamieBanner bannerData={extraData?.topBanner} bannerType="topBanner" />
            <BambuPageBanner bannerData={extraData?.topBanner} bannerType="topBanner" />
            {extraData?.topBanner && extraData?.topBanner?.banner?.image?.desktopImage?.url ? (
              <>
                <div className="mb-10 component-top-banner relative clear-both pdp-banner">
                    <Media
                      isNoWidth="true"
                      component="bannerPicture"
                      className="w-full lg:min-h-325 xl:min-h-475 object-cover object-center topBannerImage"
                      srcset={
                        extraData?.topBanner?.banner?.image
                          ?.desktopImage?.url
                      }
                      image={
                        extraData?.topBanner?.banner?.image
                          ?.smartphoneImage?.url
                      }
                      altText={
                        extraData?.topBanner?.banner?.image
                          ?.altText
                      }
                    />
                    <div className="w-full bottom-[15%] md:bottom-0 absolute md:left-70p md:top-25p md:w-400 lg:left-[72%] lg:w-[19rem] xl:w-400">
                      <div className="w-70p md:w-full lg:w-90p xl:w-full mx-auto flex flex-col md:mx-0 px-20 md:px-0 percentage-content">
                        {extraData?.topBanner?.topTextTitle && <div className="top-title">
                          <Typography
                            component="h2"
                            className="text-15 md:text-20 lg:text-18 ml-5 tracking-1 text-black font-HelveticaNeueThin"
                          >
                            {
                              extraData?.topBanner?.topTextTitle
                            }
                          </Typography>
                          <div className="flex md:max-w-280 items-center">
                            <h2 className="text-black font-extrabold font-HelveticaNeueBold text-40 md:text-85 lg:text-64 xl:text-85 leading-39 tracking-2.1 percentage-heading">
                              {
                                extraData?.topBanner?.topTextOnePercentage
                              }
                            </h2>
                            <Typography
                              component="h2"
                              className="text-18 md:text-35 lg:text-21 xl:text-32 tracking-2.1 text-black font-HelveticaNeueThin ml-5"
                              dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(extraData?.topBanner?.titleTextOne),
                              }}
                            />
                          </div>
                          <hr className="my-10 w-full bg-black h-2" />
                          {extraData?.topBanner?.bottomTextOnePercentage && 
                          <div className="top-title">
                            <div className="flex max-w-380 items-center">
                              <h2 className="text-black font-extrabold font-HelveticaNeueBold text-40 md:text-85 xl lg:text-64 leading-39 xl:text-85 tracking-2.1 md:mt-15 percentage-heading">
                                {
                                  extraData?.topBanner?.bottomTextOnePercentage
                                }
                              </h2>
                              <Typography
                                component="h2"
                                className="text-15 md:text-25 lg:text-20 xl:text-32 tracking-2.1 text-black font-HelveticaNeueThin ml-5"
                              >
                                {
                                  extraData?.topBanner?.textTwoTitle
                                }
                              </Typography>
                            </div>
                          </div>}
                        </div>}
                      </div>
                    </div>
                    <Typography
                      className="pdp-text-shadow text-black text-9 lg:text-10 md:text-13 md:leading-15 leading-13 lg:leading-[0.8rem] tracking-0.48 lg:tracking-0.67 font-HelveticaNeueMedium md:pl-0 md:w-80p md:mx-auto md:bottom-15 inline-block absolute w-full bottom-0 text-center left-0 right-0 lg:w-70p"
                      component="div"
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(extraData?.topBanner?.footerText),
                      }}
                    />
                  </div>
              </>
            ) : null}

            {/* Simple Banner Jamie second Banner*/}
            <JamieBanner bannerData={extraData?.simpleBanner} bannerType="simpleBanner" />
            <BambuPageBanner bannerData={extraData?.simpleBanner} bannerType="simpleBanner" />

            {/* Simple Banner IconImageCollection */}
            {extraData?.simpleBanner ? (
              <IconBanner {...extraData?.simpleBanner} />
            ) : null}

            {/* Middle Banner Section */}
            <BambuPageBanner bannerData={extraData?.middleBannerSection} bannerType="middleBanner" />
            {extraData?.middleBannerSection && extraData?.middleBannerSection?.bannerImage?.desktopImage?.url ?
              <SectionBanner
                isNoWidth="true"
                {...extraData?.middleBannerSection}
                isMobile={this.state.isMobile}
              />
              : null}


            {/* bottomBanner Jamie product*/}
            <JamieBanner bannerData={extraData?.bottomBanner} bannerType="bottomBanner" />
            <BambuPageBanner bannerData={extraData?.bottomBanner} bannerType="bottomBanner" />

            {/* bottomBannerSection */}
            {extraData?.bottomBanner && extraData?.bottomBanner?.imageListCollection?.items ?
              <BottomBanner
              isNoWidth="true"
              isMobile={this.state.isMobile}
              title={extraData?.bottomBanner?.title}
              footerText={extraData?.bottomBanner?.footerText}
              listItem={
                extraData?.bottomBanner?.imageListCollection
                  ?.items
              }
            /> : null}
            
            {/* ratingReviewSection Jamie Banner */}
            <JamieBanner bannerData={extraData?.ratingReviewSection} bannerType="ratingReviewBanner" />
            <BambuPageBanner bannerData={extraData?.ratingReviewSection} bannerType="ratingReviewBanner" />
            {extraData?.ratingReviewSection && extraData?.ratingReviewSection?.bannerImage?.desktopImage?.url ?
              <RatingAndReviewSection
                isNoWidth="true"
                {...extraData.ratingReviewSection}
                isMobile={this.state.isMobile}
              /> : null}







            <div className="component-top-banner lg:min-h-325 xl:min-h-475 relative clear-both pdp-banner">
              <FAQBlock faqItems={faqSectionCollection?.items} />
              <div className="bv_rating px-25 md:px-0 w-full my-10 container md:mx-auto">
                <div className="flex flex-wrap my-10">
                  <div className="w-full md:w-8/12">
                    <Typography
                      component="h2"
                      className={
                        'text-36 leading-48 text-black font-BornreadyRegular tracking-normal font-normal'
                      }
                    >
                      <FormattedMessage
                        id={ratingsReviewsID}
                        defaultMessage={
                          ratingsReviews
                        }
                      />
                    </Typography>{" "}
                  </div>
                  <div className="w-full md:w-4/12">

                  </div>
                </div>
                <div id="BV-reviews-content" class="inset">
                  <div
                    data-bv-show="review_highlights"
                    data-bv-product-id={pageData?.ratingAndReviewId}
                    data-bv-seo="false"
                  ></div>
                  <div
                    data-bv-show="reviews"
                    data-bv-product-id={pageData?.ratingAndReviewId}
                    data-bv-seo="false"
                  ></div>
                </div>
              </div>

              {product?.relatedProductsCollection &&
                product?.relatedProductsCollection.items.length !== 0 && (
                  <LazyLoad offset={-50}>
                    <>
                      <div
                        className={classNames(styles?.relatedProduct?.mainWrapper)}
                      >
                        <div
                          className={classNames(
                            styles?.relatedProduct?.headingWrapper
                          )}
                        >
                          <Typography
                            component="h3"
                            className={classNames(styles?.relatedProduct?.heading)}
                          >
                            <LazyLoad offset={-50}>
                              <>
                                {constants.recommendedProductHeading}
                              </>
                            </LazyLoad>
                          </Typography>
                        </div>
                        <ProductCarousel
                          product={product}
                          locale={pageContext.locale}
                        />
                      </div>
                    </>
                  </LazyLoad>
                )}
            </div>
          </div>
          :

          <div className={styles.pdpwrapper}>
            <HeadingBanner
              pageData={pageData}
              product={product}
              locale={pageContext.locale}
              variant={
                pageData &&
                pageData.variantsCollection &&
                pageData.variantsCollection.items
              }
              store={store}
              constants={constants}
            />

            <div id={i18nMessages?.middleSection}>
              <UserInstructions
                product={product}
                store={store}
                constants={constants}
                pageData={pageData}
                data={pageData && pageData.userInstructions}
              />
            </div>
            <div
              className={styles.prodDetailsbuyNowBtnWrapper}
              id="buyNowBtnWrapper"
            >
              <div id="buyNowBtn" className={styles.prodDetailsbuyNowBtn}>
                <BuyNowLiteComponent
                  gtinId={pageData && pageData.gtin}
                  variant={
                    pageData &&
                    pageData.variantsCollection &&
                    pageData.variantsCollection.items
                  }
                  linkText={constants.buyNow}
                  productShortName={pageData?.productShortName}
                />
              </div>
            </div>
            <div className={styles?.ingredient?.mainWrapper}>
              <div className={styles?.ingredient?.headingWrapper}>
                <Typography
                  component="h2"
                  className={classNames(styles?.ingredient?.heading)}
                >
                  <LazyLoad offset={-50}><>{constants.ingredientsTitle}</></LazyLoad>
                </Typography>
              </div>
              <div className={classNames(styles?.ingredient?.containerWrapper)}>
                <div className={styles?.ingredient?.contentWrapper}>
                  {pageData?.ingredientsSectionCollection &&
                    pageData?.ingredientsSectionCollection.items.map(item => {
                      return (
                        renderSection(item, pageContext)
                      );
                    })}
                </div>
                <div className={styles?.ingredient?.viewAllButtonWrapper}>
                  <Typography
                    component="div"
                    className={classNames(styles?.ingredient?.viewAllButton)}
                  >
                    <h4 className={styles?.ingredient?.viewAllButtonh4}>
                      <LazyLoad offset={-50}>
                        <>
                          {constants.viewAllIngredients}
                        </>
                      </LazyLoad>
                    </h4>
                  </Typography>
                  <Typography
                    component="div"
                    className={styles?.ingredient?.allIngredients}
                  >
                    <LazyLoad offset={-50}><>{pageData?.allIngredients}</></LazyLoad>
                  </Typography>
                </div>
                <div>
                  <Dialog
                    modalStyle={classNames(styles?.ingredient?.dialog.mainDiv)}
                    onClose={this.handleDialogOpen}
                    open={dialogOpen}
                    aria-labelledby="ingredient-dialog-title"
                  >
                    <DialogTitle
                      id="ingredient-dialog-title"
                      className={styles?.ingredient?.dialog.title}
                      component="div"
                    >
                      <Button
                        className={styles?.ingredient?.dialog.closeButton}
                        onClick={this.handleDialogOpen}
                        aria-label="Close ingredients dialog"
                      >
                        <span className={styles?.ingredient?.dialog.closeSpan}>
                          {'×'}
                        </span>
                      </Button>
                    </DialogTitle>
                    <DialogContent>
                      <div className={styles?.ingredient?.dialog.contentWrapper}>
                        <Typography
                          component="h2"
                          className={styles?.ingredient?.dialog.title}
                        >
                          <FormattedMessage
                            id="ingredientsTitle"
                            defaultMessage={constants.ingredientsTitle}
                          />
                        </Typography>
                        <Typography
                          component="div"
                          className={styles?.ingredient?.dialog.message}
                        >
                          {pageData?.allIngredients}
                        </Typography>
                      </div>
                    </DialogContent>
                  </Dialog>
                </div>
              </div>
            </div>
            <div>
              <input type="hidden" name="blackBox" id="ioBlackBox" />
            </div>

            <div className={styles.readreviewSection}>
              <div className={styles.readreviewWrapper}>
                {product && (
                  <ReadReview
                    productId={product.ratingAndReviewId}
                    productIdArray={[product.ratingAndReviewId]}
                    readReviewPath={`${router.pathname}#rating`}
                    title={product.productName}
                    locale={pageContext.locale}
                    pageContext={pageContext}
                    location={router}
                    store={store}
                    productPage={product}
                  />
                )}
              </div>
            </div>
            {product?.relatedProductsCollection &&
              product?.relatedProductsCollection.items.length !== 0 && (
                <LazyLoad offset={-50}>
                  <>
                    <div
                      className={classNames(styles?.relatedProduct?.mainWrapper)}
                    >
                      <div
                        className={classNames(
                          styles?.relatedProduct?.headingWrapper
                        )}
                      >
                        <Typography
                          component="h3"
                          className={classNames(styles?.relatedProduct?.heading)}
                        >
                          <LazyLoad offset={-50}>
                            <>
                              {constants.recommendedProductHeading}
                            </>
                          </LazyLoad>
                        </Typography>
                      </div>
                      <ProductCarousel
                        product={product}
                        locale={pageContext.locale}
                      />
                    </div>
                  </>
                </LazyLoad>
              )}
            {product &&
              product.relatedArticlesCollection &&
              product.relatedArticlesCollection.items.length !== 0 && (
                <LazyLoad offset={-50}>
                  <>
                    <div
                      className={classNames(styles?.moreOnThisTopic?.mainWrapper)}
                    >
                      <div
                        className={classNames(
                          styles?.moreOnThisTopic?.headingWrapper
                        )}
                      >
                        <Typography
                          component="h3"
                          className={classNames(styles?.moreOnThisTopic?.heading)}
                        >
                          <LazyLoad offset={-50}>
                            <>
                              {constants.relatedArticlesHeading}
                            </>
                          </LazyLoad>
                        </Typography>
                      </div>
                      <div>
                        <ArticleCarousel
                          articleData={product}
                          locale={pageContext.locale}
                        />
                      </div>
                    </div>
                  </>
                </LazyLoad>
              )}
            {pageData?.instagramStories && (
              <div className={classNames(styles?.fromOurInstagram?.mainWrapper)}>
                <div
                  className={classNames(styles?.fromOurInstagram?.headingWrapper)}
                >
                  <Typography
                    component="h2"
                    className={classNames(styles?.fromOurInstagram?.heading)}
                  >
                    <FormattedMessage
                      id="instagram"
                      defaultMessage={constants.instagram}
                    />
                  </Typography>
                </div>
                <div>
                  <Carousel
                    key={pageData?.instagramStories.sys.id}
                    carousel={pageData?.instagramStories}
                  />
                </div>
              </div>
            )}

          </div>
        }
      </React.Fragment>
    );
  }
}

export default withRouter(ProductDetail);